export default __webpack_public_path__ + "static/media/profesionales.60b2c2c3.png";